module.exports = __webpack_public_path__ + "static/media/jds.65a90a9e.png";